import React from 'react';

import { useReportedDeviceIssueWidgetQuery } from 'generated/graphql';



export interface IReturnAuthorization {
  problemStatements: string[];
  customerComments: string;
}

export interface IData {
  returnAuthorization: IReturnAuthorization | null;
}

export function useQuery(returnAuthorizationId: string) {
  const tuple = useReportedDeviceIssueWidgetQuery({
    variables: {
      returnAuthorizationId
    }
  });

  return React.useMemo(
    () => {
      const returnAuthorization = tuple.data?.tier1ReturnAuthorization;
      const data: IData = {
        returnAuthorization: returnAuthorization ? {
          problemStatements: returnAuthorization.problemStatements,
          customerComments: returnAuthorization.customerComment
        } : null
      };

      return {
        ...tuple,
        data
      };
    },
    [tuple]
  );
}
